/**
 * Сумма прописью для актов и закрытия дня: «двести сорок пять тысяч
 * триста двадцать тенге 50 тиын». Женский род тысяч учтён.
 */
const ONES = ['', 'один', 'два', 'три', 'четыре', 'пять', 'шесть', 'семь', 'восемь', 'девять'];
const ONES_F = ['', 'одна', 'две', 'три', 'четыре', 'пять', 'шесть', 'семь', 'восемь', 'девять'];
const TEENS = ['десять', 'одиннадцать', 'двенадцать', 'тринадцать', 'четырнадцать',
  'пятнадцать', 'шестнадцать', 'семнадцать', 'восемнадцать', 'девятнадцать'];
const TENS = ['', '', 'двадцать', 'тридцать', 'сорок', 'пятьдесят',
  'шестьдесят', 'семьдесят', 'восемьдесят', 'девяносто'];
const HUNDREDS = ['', 'сто', 'двести', 'триста', 'четыреста', 'пятьсот',
  'шестьсот', 'семьсот', 'восемьсот', 'девятьсот'];

function triple(n: number, feminine: boolean): string {
  const parts: string[] = [];
  const h = Math.floor(n / 100);
  const t = Math.floor((n % 100) / 10);
  const o = n % 10;
  if (h) parts.push(HUNDREDS[h]!);
  if (t === 1) parts.push(TEENS[o]!);
  else {
    if (t) parts.push(TENS[t]!);
    if (o) parts.push((feminine ? ONES_F : ONES)[o]!);
  }
  return parts.join(' ');
}

function plural(n: number, forms: [string, string, string]): string {
  const m10 = n % 10;
  const m100 = n % 100;
  if (m10 === 1 && m100 !== 11) return forms[0];
  if (m10 >= 2 && m10 <= 4 && (m100 < 12 || m100 > 14)) return forms[1];
  return forms[2];
}

/** Тиыны → «… тенге NN тиын». До 999 999 999 ₸ — хватит и сети. */
export function tengeInWords(tiyn: number): string {
  const total = Math.trunc(Math.abs(tiyn));
  const kzt = Math.trunc(total / 100);
  const t = total % 100;
  const millions = Math.trunc(kzt / 1_000_000);
  const thousands = Math.trunc((kzt % 1_000_000) / 1000);
  const rest = kzt % 1000;

  const parts: string[] = [];
  if (millions) parts.push(triple(millions, false), plural(millions, ['миллион', 'миллиона', 'миллионов']));
  if (thousands) parts.push(triple(thousands, true), plural(thousands, ['тысяча', 'тысячи', 'тысяч']));
  if (rest || kzt === 0) parts.push(kzt === 0 ? 'ноль' : triple(rest, false));
  parts.push('тенге', String(t).padStart(2, '0'), 'тиын');
  return (tiyn < 0 ? 'минус ' : '') + parts.filter(Boolean).join(' ');
}
